import { Globe2, Anchor, Truck, Route } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export default function About() {
  return (
    <section id="about" className="relative bg-[#070F1E] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>About Us</Eyebrow>
              <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
                One bridge between worldwide supply and the U.S. market.
              </h2>
              <p className="mt-5 text-base leading-relaxed text-slate-400">
                PORTBRIDGE Global is a worldwide supplier and importer connecting global
                manufacturers, growers and distributors with customers across the United States. We
                handle the full journey — sourcing, documentation, port operations and inland
                delivery — under one accountable team.
              </p>
              <p className="mt-4 text-base leading-relaxed text-slate-400">
                Our carrier network is built on verification, not volume. Every trucking partner is
                approved before the first dispatch.
              </p>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-8">
            <Reveal className="sm:col-span-2" delay={0.05}>
              <div className="relative h-64 overflow-hidden rounded-2xl border border-[#0066FF]/20 sm:h-72">
                <img
                  src="https://images.unsplash.com/photo-1759272840538-ae4b07214c71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNvbnRhaW5lciUyMHRlcm1pbmFsfGVufDB8fHx8MTc5MDYwNjYyNXww&ixlib=rb-4.1.0&q=85"
                  alt="Shipping containers stacked at a busy port"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#070F1E]/90 via-[#070F1E]/40 to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF]">Port To Porch</p>
                  <p className="mt-2 max-w-md font-display text-xl font-bold text-white sm:text-2xl">
                    Ocean freight, customs clearance and final-mile delivery — managed end to end.
                  </p>
                </div>
              </div>
            </Reveal>

            {[
              {
                icon: Globe2,
                title: "Who We Are",
                text: "Global suppliers and importers serving U.S. customers across retail, food, construction and manufacturing.",
              },
              {
                icon: Anchor,
                title: "What We Bridge",
                text: "The distance between an overseas supplier's dock and a U.S. customer's door — documentation, terminals, drayage and all.",
              },
              {
                icon: Truck,
                title: "How We Move",
                text: "Dry van, reefer and flatbed capacity, matched to freight by equipment class and lane history.",
              },
              {
                icon: Route,
                title: "Where We're Headed",
                text: "A 20,000-load national program launching November 1 — our largest coordinated capacity commitment to date.",
              },
            ].map((card, i) => (
              <Reveal key={card.title} delay={0.08 + i * 0.06}>
                <div className="h-full rounded-2xl border border-[#0066FF]/20 bg-[#0B172A] p-6 transition-colors hover:border-[#0066FF]/50">
                  <card.icon className="h-6 w-6 text-[#00F0FF]" />
                  <h3 className="mt-4 font-display text-lg font-bold text-white">{card.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{card.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
